module.exports = __webpack_public_path__ + "static/media/paragon-paraco.0fd82d6c.png";